export const initialFormValues = {
  economicGroup: '',
  profitCenter: '',
  budget: '',
  actualPreview: '',
  deviationVsBudget: '',
  accounts: [
    {
      account: '',
      returnJustification: '',
      draftItemId: '' as string
    }
  ]
}
